// frontend/src/components/CalendarTaskItem.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Flag, CheckCircle } from 'lucide-react';
import { DEFAULT_PROJECT_PRIORITY_VALUE, getProjectPriorityInfo } from '../utils/projectPriority';

const CalendarTaskItem = ({ task, objectiveForTask, projectForObjective }) => {
    const isDue = !task.is_completed;
    const projectPriorityInfo = projectForObjective
        ? getProjectPriorityInfo(projectForObjective.pilotage_priority, DEFAULT_PROJECT_PRIORITY_VALUE)
        : null;
    
    return (
        <div 
            // --- NOUVEAU : Ajout des attributs pour le Drag & Drop ---
            draggable
            onDragStart={(e) => {
                // Empêche le drag de se propager vers la cellule du calendrier parent
                e.stopPropagation(); 
                // On embarque l'objet de la tâche, comme pour les autres items
                e.dataTransfer.setData('application/json', JSON.stringify(task));
            }}
            // --- FIN NOUVEAU ---
            className={`p-1 rounded text-xs cursor-pointer hover:shadow-md transition-shadow active:cursor-grabbing ${isDue ? 'bg-red-100 border border-red-200' : 'bg-green-100 border border-green-200'}`}
                        title={task.name}
        >
            <div className="flex items-center space-x-1">
                {isDue ? 
                    <Flag size={10} className="text-red-600 flex-shrink-0" /> : 
                    <CheckCircle size={10} className="text-green-600 flex-shrink-0" />
                }
                <p className="truncate font-medium flex-grow">{task.name}</p>
            </div>
            {objectiveForTask && (
                 <Link 
                    to={`/objectives?project=${objectiveForTask?.project_id}&objective=${task.objective_id}`}
                    onClick={(e) => e.stopPropagation()} 
                    className="text-blue-600 hover:underline truncate block"
                 >
                    <span className="truncate">{objectiveForTask.name}</span>
                    {projectForObjective && <span className="ml-2 text-gray-400 font-light truncate">#{projectForObjective.name}</span>}
                 </Link>
            )}
            {projectPriorityInfo && (
                <span className={`mt-1 inline-flex rounded-full border px-1.5 py-0.5 text-[9px] font-semibold ${projectPriorityInfo.className}`}>
                    P{projectPriorityInfo.value}
                </span>
            )}
        </div>
    );
};

export default CalendarTaskItem;
